import { create } from 'zustand'

import type { LiveCoinMarket } from '@/types/coin'

interface CoinStoreState {
  // Live coin market data from websocket message
  liveCoinMarket: LiveCoinMarket
}

interface CoinStoreAction {
  clear: () => void
}

const initialState: CoinStoreState = {
  liveCoinMarket: {},
}

const useCoinStore = create<CoinStoreState & CoinStoreAction>()(set => ({
  ...initialState,
  clear: () => set({ liveCoinMarket: {} }),
}))

export default useCoinStore
